import { UI, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { RouteProp, useRoute } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';

import { CustomerDetailTypes } from '../..';
import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { SignedInRootStackParamList } from '../../../../routes/types';
import { updateCustomerDetailsEmail } from '../../../../store/customerDetail/privatePension/selectors';
import { customerDetailQuery } from '../../../../store/customerDetail/selector';

import {
  PrivatePensionContactedAvailableTabs,
  PrivatePensionContactedInitialTab,
  privatePensionContactedTabs,
} from './constants';

export const PrivatePensionContacted: React.FC<CustomerDetailTypes.Props> = () => {
  const { params } =
    useRoute<RouteProp<SignedInRootStackParamList, 'PrivatePensionNewApplicationModal'>>();

  const [nextTab, setNextTab] = useState<PrivatePensionContactedAvailableTabs>();
  const [selectedTab, setSelectedTab] = useState<PrivatePensionContactedAvailableTabs>(
    PrivatePensionContactedInitialTab
  );

  const setCustomerDetailsEmail = useSetRecoilState(updateCustomerDetailsEmail);

  const { data } = useRecoilQuery(customerDetailQuery({ ...params }));

  const ContentComponent = privatePensionContactedTabs[selectedTab].component;

  useEffect(() => {
    if (nextTab !== undefined) {
      setSelectedTab(nextTab);
    }
  }, [nextTab]);

  useEffect(() => {
    if (data?.email) {
      setCustomerDetailsEmail(data.email);
    }
  }, [data, setCustomerDetailsEmail]);

  return (
    <UI.Shadow
      level={1}
      borderRadius={BoxBorder.heavy}
      my={Spacing['inset.sm']}
      paddingX={Spacing['inline.xxxs']}
      paddingY={Spacing['inline.xxs']}>
      <VStack space={Spacing['stack.xxs']}>
        <ContentComponent setSelectedTab={setNextTab} />
      </VStack>
    </UI.Shadow>
  );
};
